const findWrapper = (el, within) => {
  return el.parentElement === within ? el : findWrapper(el.parentElement, within);
}


const findPreviousImage = (el) => {
  if (!el) return null;

  const img = el.previousElementSibling?.querySelector('img');

  return img ? img : findPreviousImage(el.previousElementSibling);
}

class ShoppableImageProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.enabled) return;

    const article = this.closest('article-content');
    const wrapper = findWrapper(this, article);

    const img = findPreviousImage(wrapper);

    if (!img) return;

    const imgWrapper = findWrapper(img, article);

    imgWrapper.outerHTML = `
      <shoppable-image src="${img.src}" alt="${img.alt}" handles="${this.handles}"></shoppable-image>
    `;

    // find parent of this
    // find closest prior sibing with an img element
    // Replace img element and any wrappers with shoppable-image
    // shoppable-image renders image and any shoppable products
  }

  disconnectedCallback() {

  }

  get handles() {
    return (this.getAttribute('handles') || '').split(',');
  }

  get enabled() {
    return this.hasAttribute('enabled');
  }
}

if (!customElements.get("shoppable-image-products")) {
  customElements.define("shoppable-image-products", ShoppableImageProducts);
}
